import {
  Modal,
  ModalContent,
  ModalOverlay,
  ModalBody,
  ModalFooter,
  Text,
  Heading,
  Button,
  HStack,
  StackDivider,
} from '@chakra-ui/react';

type ConcatModalProps = {
  isOpen: boolean;
  onClose: () => void;
  phoneNumber: string;
};

export default function ConcatModal({ isOpen, phoneNumber, onClose }: ConcatModalProps) {
  return (
    <Modal isOpen={isOpen} onClose={onClose} size="xs" isCentered>
      <ModalOverlay />
      <ModalContent>
        <ModalBody py={6}>
          <Heading textAlign="center" size="md" mb={2}>
            平台已接單
          </Heading>
          <Text color="gray.500" textAlign="center" fontSize="sm">
            如要取消或修改請聯絡平台
            <br />
            平台電話 {phoneNumber}
          </Text>
        </ModalBody>
        <ModalFooter p={0}>
          <HStack w="full" align="stretch" space={0} borderTopWidth="1px" borderColor="gray.100">
            <Button
              flex="1"
              isFullWidth
              bgColor="transparent"
              color="fontColor"
              fontWeight="normal"
              _hover={{}}
              onClick={onClose}
            >
              我想一下
            </Button>
            <StackDivider w="1px" ml={0} bgColor="gray.100" />
            <Button
              flex="1"
              isFullWidth
              bgColor="transparent"
              color="fontColor"
              fontWeight="normal"
              _hover={{}}
              onClick={() => window.open(`tel:${phoneNumber}`)}
            >
              確定
            </Button>
          </HStack>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
}
